import React from 'react'
import { useTranslation } from 'react-i18next';

export const REGIONS = [
  "Toshkent shahri", "Toshkent viloyati", "Andijon", "Buxoro", "Farg'ona", "Jizzax", "Xorazm",
  "Namangan", "Navoiy", "Qashqadaryo", "Qoraqalpog'iston", "Samarqand", "Sirdaryo", "Surxondaryo",
];

export const TASHKENT_DISTRICTS = [
  "Bektemir", "Chilonzor", "Mirobod", "Mirzo Ulug'bek", "Olmazor", "Sergeli", "Shayxontohur",
  "Uchtepa", "Yakkasaroy", "Yangihayot", "Yashnobod", "Yunusobod",
];

// value: { region, district }; onChange(next) — hudud o'zgarsa tuman tozalanadi
export default function RegionSelect({ region, district, onChange, className = 'input-col patner_cols', allowAll = false }) {
  const { t } = useTranslation();
  const style = { width: '100%', padding: 12, borderRadius: 10, border: '1px solid #B9C4BD', fontSize: 16, background: '#fff' };
  return (
    <>
      <div className={className}>
        <p>{t('Viloyat / shahar')}</p>
        <select value={region || ''} onChange={e => onChange({ region: e.target.value, district: '' })} style={style} aria-label={t('Viloyat')}>
          <option value=''>{allowAll ? t('Hammasi') : t('Tanlang')}</option>
          {REGIONS.map(r => <option key={r} value={r}>{r}</option>)}
        </select>
      </div>
      <div className={className}>
        <p>{t('Tuman')}</p>
        {region === 'Toshkent shahri' ? (
          <select value={district || ''} onChange={e => onChange({ region, district: e.target.value })} style={style} aria-label={t('Tuman')}>
            <option value=''>{allowAll ? t('Hammasi') : t('Tanlang')}</option>
            {TASHKENT_DISTRICTS.map(d => <option key={d} value={d}>{d}</option>)}
          </select>
        ) : (
          <input value={district || ''} disabled={!region} placeholder={region ? t('Tuman nomi') : t('Avval viloyatni tanlang')}
            onChange={e => onChange({ region, district: e.target.value })} style={style} aria-label={t('Tuman')} />
        )}
      </div>
    </>
  );
}
